/* Bay of Hayley — productpagina
 * Microcopy onder de winkelwagenknop wisselt bij aantal ≥ 2
 * ("Je 2e sieraad is gratis — wordt automatisch verrekend") — Early Black Friday 1 + 1.
 * De prijs in de knop (prijs × aantal) regelt het thema zelf; de doorgestreepte
 * prijs in de knop wordt via boh-product.css verborgen.
 */
(function () {
  'use strict';

  var FREE_FROM_QTY = 2;

  function update(form) {
    var micro = form.querySelector('[data-boh-micro]');
    if (!micro) return;
    var input = form.querySelector('input[name="quantity"]');
    var qty = input ? parseInt(input.value, 10) || 1 : 1;
    var text = qty >= FREE_FROM_QTY ? micro.getAttribute('data-micro-three') : micro.getAttribute('data-micro-default');
    if (text && micro.textContent !== text) micro.textContent = text;
    var btn = form.querySelector('[data-add-to-cart]');
    if (btn) micro.hidden = btn.hasAttribute('disabled');
  }

  function bind(form) {
    if (form.__bohBound) return;
    form.__bohBound = true;
    form.addEventListener('change', function () { update(form); });
    form.addEventListener('input', function () { update(form); });
    // variant-wissel (uitverkocht/beschikbaar) → knopstatus volgen
    var btn = form.querySelector('[data-add-to-cart]');
    if (btn && window.MutationObserver) {
      new MutationObserver(function () { update(form); }).observe(btn, { attributes: true, attributeFilter: ['disabled'] });
    }
    update(form);
  }

  function init() {
    document.querySelectorAll('form[data-product-form]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
